<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageRoomTypes.title') }}
    </portal>
    <template v-if="roomTypes !== null">
      <card :title="$t('admin.pageRoomTypes.card.roomTypes')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <draggable v-model="roomTypes" group="roomTypes">
              <hm-card-inner-line v-for="roomType in roomTypes"
                                  v-if="!roomType.deleted"
                                  :title="getName
                                  (roomType)"
                                  :clickable="true"
                                  :key="roomType.id"
                                  @click="routeToRoomType(roomType)" />
            </draggable>
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedRoomTypes)" :title="$t('admin.pageRoomTypes.card.deletedRoomTypes')" cols="12" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner-line v-for="roomType in deletedRoomTypes"
                              :title="getName(roomType)"
                              :clickable="true"
                              :key="roomType.id"
                              @click="routeToRoomType(roomType)" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pageRoomTypes.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button :label="$t('admin.pageRoomTypes.actions.addRoomType')" icon="plus" color="blue" @click="addRoomType()" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, groupBy, isEmpty, isNil, sortBy, first } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';

export default {
  name: 'PageRoomTypes',

  components: {
    draggable,
  },

  autosave: [
    {
      name: 'roomTypes',
      variable: 'sortedRoomTypeIds',
      event: 'hotelSettings.update',
      fn: function (cbSaveComplete) {
        const update = {
          roomTypeIds: this.sortedRoomTypeIds,
        };

        this.axios.put(this.serviceUrls.roomType.sort(this, this.$route.params.roomTypeId), update)
          .then((response) => {
            this.showMessages(response);
            cbSaveComplete();
            this.$serviceBus.$emit('roomType.list', this.ratePlans);
          })
          .catch((error) => {
            this.showMessages(error.response);
            cbSaveComplete();
          });
      },
    },
  ],

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      roomTypes: null,
    };
  },

  computed: {
    deletedRoomTypes: function () {
      return isNil(this.roomTypes) ? null : this.roomTypes.filter(it => it.deleted === true);
    },
    sortedRoomTypeIds: function () {
      return isNil(this.roomTypes) ? null : this.roomTypes.map(it => it.id);
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.roomType.list(this))
        .then((response) => {
          this.roomTypes = response.data.data;
          this.$serviceBus.$emit('roomType.list', this.roomTypes);
        });
    },
    addRoomType() {
      this.axios.post(this.serviceUrls.roomType.list(this), {
        name: {
          [this.hotelSettings.details.primaryLanguage]: this.$t('admin.pageRoomTypes.newRoomTypeName'),
        },
        description: {
          [this.hotelSettings.details.primaryLanguage]: '',
        },
        abbreviation: '',
        minOccupancy: 1,
        expectedOccupancy: 2,
        maxOccupancy: 2,
        publicVisible: false,
        occupancyBasedRates: true,
      })
        .then((response) => {
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(roomType) {
      const name = isNil(roomType) ? null : roomType.name;
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      let details = '';

      if (roomType.deleted === false) {
        details += `, ${this.$t('admin.pageRoomTypes.description.abbreviation')}: ${roomType.abbreviation}`;

        if (roomType.publicVisible === true) {
          details += `, ${this.$t('admin.pageRoomTypes.description.public')}`;
        }

        if (!isEmpty(roomType.parentRoomTypeId)) {
          const parentRoomType = first(this.roomTypes.filter(it => it.id === roomType.parentRoomTypeId));
          details += `, ${this.$t('admin.pageRoomType.parentRoomTypeId')}: <i>${parentRoomType.name[this.$shortLocale] || parentRoomType.name[this.hotelSettings.details.primaryLanguage]}</i>`;
        }

        details += `, ${this.$t('admin.pageRoomTypes.description.personCapacity')}: ${roomType.minOccupancy} - ${roomType.maxOccupancy}, ${this.$t('admin.pageRoomTypes.description.roomCount')}: ${roomType.roomCount}`;
      }

      if (!isNil(ret)) {
        ret = ret.trim();
      }

      if (isEmpty(ret)) {
        ret = '-';
      }

      ret = `${ret}<span class="color--gray">${details}</span>`;

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeToRoomType(roomType) {
      this.$router.push({
        name: 'roomType',
        params: {
          roomTypeId: roomType.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageRoomTypes.vue